import React, { useRef, useState } from "react";
import { Box } from "@mui/material";

const ScrollContainer = ({ children, ...props }) => {
    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollStart, setScrollStart] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX);
        setScrollStart(scrollRef.current.scrollLeft);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        const x = e.pageX;
        const walk = (x - startX) * 1.5;
        scrollRef.current.scrollLeft = scrollStart - walk;
    };

    return (
        <Box
            ref={scrollRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onMouseMove={handleMouseMove}
            sx={{
                display: "flex",

                cursor: isDragging ? "grabbing" : "grab",
                overflowX: "scroll",
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
                "&::-webkit-scrollbar": {
                    display: "none", // Chrome/Safari
                },

                "& img": {
                    pointerEvents: "none",
                    userSelect: "none",
                    draggable: false, // not CSS, but good reminder
                },
            }}
            {...props}>
            {children}
        </Box>
    );
};

export default ScrollContainer;
